module.exports = __webpack_public_path__ + "img/muller_mylogy.4b70699b.jpg";